import { EFFECT_KIND, TARGET_KIND } from '../data/disasters.js';
import { FAMILY } from '../data/families.js';
import { PLANT_TYPE } from '../data/plants.js';
import { outputMultiplierFactorForPlant } from '../engine/disasters.js';

function targetMatchesAnyOwned(target, portfolio, plantsById) {
  switch (target.kind) {
    case TARGET_KIND.PLANTS:
      return portfolio.some((id) => target.ids.includes(id));
    case TARGET_KIND.FAMILY:
      return portfolio.some((id) => plantsById[id]?.family === target.family);
    case TARGET_KIND.ALL_VARIABLE:
      return portfolio.some(
        (id) => plantsById[id]?.type === PLANT_TYPE.VARIABLE
      );
    case TARGET_KIND.LARGEST_NON_NUCLEAR_FAMILY:
      return portfolio.some((id) => {
        const family = plantsById[id]?.family;
        return family && family !== FAMILY.NUCLEAR;
      });
    case TARGET_KIND.LARGEST_FAMILY:
      return portfolio.some((id) => Boolean(plantsById[id]?.family));
    case TARGET_KIND.PLAYER:
      return true;
    default:
      return false;
  }
}

export function disasterImpactsPlayer(disaster, ctx) {
  const { portfolio, plantsById, subsidyActive } = ctx;
  const e = disaster.effect;
  const t = disaster.target;

  switch (e.kind) {
    case EFFECT_KIND.OUTPUT_MULTIPLIER:
      return portfolio.some(
        (id) =>
          targetMatchesAnyOwned(t, [id], plantsById) &&
          outputMultiplierFactorForPlant(e, id) !== 1
      );
    case EFFECT_KIND.OPEX_MULTIPLIER:
      if (e.factor === 1) return false;
      return targetMatchesAnyOwned(t, portfolio, plantsById);
    case EFFECT_KIND.DEMAND_ADD:
      return e.amount !== 0;
    case EFFECT_KIND.SUBSIDY_REMOVE:
      if (!subsidyActive) return false;
      return portfolio.some(
        (id) => plantsById[id]?.family === FAMILY.FOSSIL_THERMAL
      );
    default:
      return false;
  }
}

export function impactfulDrawnDisasters(disasters, ctx) {
  return disasters.filter((d) => disasterImpactsPlayer(d, ctx));
}

export function affectedPlantIds(disaster, portfolio, plantsById) {
  const t = disaster.target;
  switch (t.kind) {
    case TARGET_KIND.PLANTS:
      return portfolio.filter((id) => t.ids.includes(id));
    case TARGET_KIND.FAMILY:
      return portfolio.filter((id) => plantsById[id]?.family === t.family);
    case TARGET_KIND.ALL_VARIABLE:
      return portfolio.filter(
        (id) => plantsById[id]?.type === PLANT_TYPE.VARIABLE
      );
    case TARGET_KIND.LARGEST_NON_NUCLEAR_FAMILY: {
      const counts = {};
      for (const id of portfolio) {
        const family = plantsById[id]?.family;
        if (!family || family === FAMILY.NUCLEAR) continue;
        counts[family] = (counts[family] ?? 0) + 1;
      }
      const maxCount = Math.max(0, ...Object.values(counts));
      if (maxCount === 0) return [];
      const family = Object.keys(counts)
        .filter((f) => counts[f] === maxCount)
        .sort()[0];
      return portfolio.filter((id) => plantsById[id]?.family === family);
    }
    case TARGET_KIND.LARGEST_FAMILY: {
      const counts = {};
      for (const id of portfolio) {
        const family = plantsById[id]?.family;
        if (!family) continue;
        counts[family] = (counts[family] ?? 0) + 1;
      }
      const maxCount = Math.max(0, ...Object.values(counts));
      if (maxCount === 0) return [];
      const family = Object.keys(counts)
        .filter((f) => counts[f] === maxCount)
        .sort()[0];
      return portfolio.filter((id) => plantsById[id]?.family === family);
    }
    default:
      return [];
  }
}
